import { createContext, useContext, useEffect, ReactNode } from "react";
import { UtilisateurDto } from "@/types/UtilisateurType";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthStore } from "./stores";
import { getCurrentUserDashboard } from "@/composables/auth/utils";

type AuthContextType = {
  user: UtilisateurDto | null;
  isAuthenticated: boolean;
  // setUser: React.Dispatch<React.SetStateAction<UtilisateurDto | null>>;
  // updateUser: () => Promise<void>;
  // login: () => void;
  // logout: () => void;
};

const AuthContext = createContext<AuthContextType | undefined>(undefined);

type AuthProviderProps = {
  children: ReactNode;
};

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const { isAuthenticated, currentUser } = useAuthStore();

  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    // Define auth and protected pages
    const isAuthPage =
      pathname === "/connexion" ||
      pathname === "/inscription" ||
      pathname.startsWith("/auth");
    const isProtectedPage = pathname.startsWith("/dashboard");

    // Redirect logic
    // if (isAuthenticated && isAuthPage) {
    //   navigate(currentUser ? getCurrentUserDashboard(currentUser) : "/");
    // } else if (!isAuthenticated && isProtectedPage) {
    //   navigate(`/connexion?redirect=${encodeURIComponent(pathname)}`);
    // }
  }, [pathname, navigate, isAuthenticated]);

  return (
    <AuthContext.Provider value={{ isAuthenticated, user: currentUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
